import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckoutNewRoutingModule } from './checkout-new-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CheckoutNewRoutingModule
  ]
})
export class CheckoutNewModule { }



/**
 * Modal for Checkout Request
 */
export class MCheckoutRequest {
  user_id!: string
  productorderdetails: any = [MCheckoutProductRequest]
  user_address_id!: string
  warehouse_id!: number
  order_number!: number
  order_tracking_number!: number
  total_cost!: any;
  total_discount_amount!: number
  total_redeem_point!: number
  payment_id!: string
  delivery_date!: string
  shipping_charge!: number
  total_tax_amount!: number
  cod: any;
  discount_code: any;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

/**
 * Modal for Checkout Product Request
 */
export class MCheckoutProductRequest {
  product_id!: number
  qty!: number
  product_price!: number
  hsn!: string
  tax!: number
  discount_type!: string
  discount_type_id!: string
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

